import React from "react";
import useIsMobile from "../hooks/useIsMobile";
import ShipmentsMobile from "../mobile/logistics/ShipmentsMobile";
import ShipmentList from "./components/ShipmentList";

export default function ResponsiveShipmentList(props) {
  return useIsMobile() ? <ShipmentsMobile {...props} /> : <ShipmentList {...props} />;
}
